import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=4f573c4f&scoped=true"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditQuestion.vue?vue&type=style&index=0&id=4f573c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f573c4f",
  null
  
)

export default component.exports